import UsaLayout from "./layout/USALayout";
import AboutHeader from "./USA-Components/AboutHeader";
import Mission from "./USA-Components/Mission";
import AboutQandA from "./USA-Components/AboutQandA";
import ItMatters from "./USA-Components/ItMatters";
import AboutBottom from "./USA-Components/AboutBottom";

const USAboutUs = () => {
    return (
        <UsaLayout>
            <>
            <AboutHeader/>
            <Mission/>
            <AboutQandA/>
            <ItMatters/>
            <AboutBottom/>
            </>
        </UsaLayout>
    )
}

export default USAboutUs
;